module.exports = "<div class=chromecast-playback-background></div><div class=chromecast-playback-overlay></div>";


//////////////////
// WEBPACK FOOTER
// ./src/public/chromecast.html
// module id = 3
// module chunks = 0